export default __webpack_public_path__ + "static/media/Group 3053.9a00123f.png";